export enum ActivityVisualization {
    Dia = 1,
    Semana = 2,
    Mensual = 3
}

export enum ActivityStatusVisualization {
    Vencidas = 1,
    AVencer = 2,
    Futuras = 3,
    Realizadas = 4
}

export enum ActivityStatusClassification {
    Pendiente = 1,
    Finalizada = 2,
    Anulada = 3,
    Vencida = 4,
    Futura = 5
}

export enum ActivityType {
    Solicitud = 1,
    Cliente = 2,
    Tarea = 3,
    Reclamo = 4
}

export enum ActivityTracing {
    WithTracing = 1,
    WithoutTracing = 2
}

export enum ActivityStatus {
    ConSeguimiento_Pendiente = 1,
    ConSeguimiento_EnCurso = 2,
    ConSeguimiento_Resuelta = 3,
    ConSeguimiento_Finalizada = 4,
    ConSeguimiento_Anulada = 5,
    ConSeguimiento_MasInformacion = 9,
}